var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mr-plan-header" },
    [
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "top",
                    "label-width": "8em",
                    inline: true,
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex", gutter: 12 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 24, md: 24 } },
                        [
                          _vm.$props.type === "manual"
                            ? _c(
                                "el-form-item",
                                { staticClass: "d-none d-md-inline-block" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        disabled: _vm.isManualAssignLoading,
                                        filterable: "",
                                        placeholder: _vm.$t(
                                          "planning.placeholder.planId"
                                        ),
                                      },
                                      model: {
                                        value: _vm.selectedPlanId,
                                        callback: function ($$v) {
                                          _vm.selectedPlanId = $$v
                                        },
                                        expression: "selectedPlanId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.planIds,
                                      function (planId, index) {
                                        return _c("el-option", {
                                          key: planId,
                                          attrs: {
                                            label: planId,
                                            value: planId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.$props.type === "manual"
                            ? _c(
                                "el-form-item",
                                { staticClass: "d-none d-md-inline-block" },
                                [
                                  _c("el-tooltip", [
                                    _vm.isAssignToTruckDisabled
                                      ? _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.tooltip.assignTruckWarningTitle"
                                                  )
                                                )
                                            ),
                                            _c("br"),
                                            _vm.getAssignTruckDisabledDetails
                                              .reason1
                                              ? _c("span", [
                                                  _vm._v(
                                                    "· " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.assignTruckWarning2"
                                                        )
                                                      )
                                                  ),
                                                  _c("br"),
                                                ])
                                              : _vm._e(),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.assignToTruck"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                    _c(
                                      "span",
                                      { staticClass: "disabled-btn-wrapper" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "success",
                                              size: "mini",
                                              disabled:
                                                _vm.isAssignToTruckDisabled ||
                                                _vm.isManualAssignLoading,
                                              loading:
                                                _vm.isManualAssignLoading,
                                            },
                                            on: { click: _vm.assignToTruck },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: "truck-moving",
                                                "aria-hidden": "true",
                                                size: "lg",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }